<template>
  <router-view />
</template>

<script>
export default {
  name: "workshopMain",
};
</script>